export const QA_NAME_AUTH_FOOTER_ABOUT_LINK = 'authFooterAboutLink'

export const QA_NAME_AUTH_FOOTER_HELP_CENTER_LINK = 'authFooterHelpCenterLink'
